import { createApp } from 'vue';
import M4aToMp3Converter from '@/Components/M4aToMp3Converter.vue';
import '@styles/app.css';

createApp(M4aToMp3Converter).mount('#m4a-to-mp3-converter');
